/* global I18n */

import { Component } from "react";
import Clipboard from "clipboard";
import { sendJSON } from "../../utils/request";

const i18nOptions = {
  scope: "components.clipboard_widget",
};

class ClipboardModal extends Component {
  state = {
    showTooltip: false,
    sendingLink: false,
  };

  componentDidMount() {
    this.clipboard = new Clipboard(this.clipboardButtonRef);
    this.clipboard.on("success", () => {
      this.setState({ showTooltip: true });
    });
  }

  componentWillUnmount() {
    this.clipboard.destroy();
  }

  tooltip = () => {
    if (this.state.showTooltip) {
      return (
        <div
          className="tooltip bottom in"
          role="tooltip"
          id="clipboard-tooltip-copied"
        >
          <div className="tooltip-arrow"></div>
          <div className="tooltip-inner">{I18n.t("copied", i18nOptions)}</div>
        </div>
      );
    }
  };

  handleHideTooltip = () => {
    this.setState({ showTooltip: false });
  };

  handleSendLink = () => {
    this.setState({ sendingLink: true });

    // Reset on failure too: a network error used to leave the button spinning for good.
    sendJSON(this.props.authenticationLinksPath, { method: "POST" })
      .catch(() => {})
      .finally(() => {
        this.setState({ sendingLink: false });
      });
  };

  render() {
    return (
      <div
        className="modal fade in"
        style={{ display: "block" }}
        tabIndex="-1"
        role="dialog"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="close"
                onClick={this.props.handleCloseModal}
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 className="modal-title">
                {I18n.t("direct_link", i18nOptions)}
              </h4>
            </div>
            <div className="modal-body">
              <div className="form-group">
                <div className="input-group">
                  <input
                    id="clipboard-text"
                    type="text"
                    className="form-control"
                    value={this.props.clipboardText}
                    readOnly
                  />
                  <span className="input-group-btn">
                    <button
                      className="btn btn-white"
                      data-clipboard-target="#clipboard-text"
                      ref={(button) => (this.clipboardButtonRef = button)}
                      onMouseLeave={this.handleHideTooltip}
                    >
                      <i className="fa fa-clipboard" aria-hidden="true"></i>
                    </button>
                    {this.tooltip()}
                  </span>
                </div>
              </div>
              <button
                className="btn btn-primary"
                disabled={this.state.sendingLink}
                onClick={this.state.sendingLink ? null : this.handleSendLink}
              >
                {this.state.sendingLink
                  ? I18n.t("sending_link", i18nOptions)
                  : I18n.t("send_link_to_owner", i18nOptions)}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ClipboardModal;
